import {
  Calls,
  CallTime,
  serializeHistory,
} from "V2.0/HomePages/Dashboard";
import ConversationStats from "./ConversationStats";
import CallQueueStatsV2 from "./CallQueueStatsV2";

export default function VoiceAssitantUsageAndStats(props) {
  const {
    assistantUsage,
    workspaceId,
    assistantId,
    syncAssistant,
    communicationQueueSettings,
    locked
  } = props;

  const data = assistantUsage?.current;
  const history = serializeHistory(assistantUsage?.history);

  return (
    <div className="mt-4 p-8 space-y-4">
      <div className="grid grid-cols-1 grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-8">
        <div className="col-span-2 2xl:col-span-1">
          <CallQueueStatsV2
            workspaceId={workspaceId}
            assistantId={assistantId}
            syncAssistant={syncAssistant}
            communicationQueueSettings={communicationQueueSettings}
            locked={locked}
          />
        </div>
        <div className="col-span-3 2xl:col-span-2">
          <ConversationStats
            workspaceId={workspaceId}
            assistantId={assistantId}
          />
        </div>
        <div className="rounded-lg border p-8">
          <Calls
            current={data}
            history={history}
          />
        </div>
        <div className="rounded-lg border p-8">
          <CallTime
            current={data}
            history={history}
          />
        </div>
      </div>
    </div>
  );
}
